//export const API_URL = 'http://localhost:3011';
export const API_URL = 'https://api.tuyensinh247.com';
export const LIMIT_COMMENT_ITEM = 10;
export const LIMIT_SUBCOMMENT_ITEM = 5;
export const API_DOMAIN = 'api.tuyensinh247.com';
export const WEB_DOMAIN = 'https://tuyensinh247.com';